import React from 'react'
import SliderGallery from '../components/SliderGallery'

const SolidGreyGallery = () => {

  const galleryImages = [
    // {
    //   img: "/assets/Solid Grey install.png",
    //   alt: 'Dec-Tec membrane in various applications and settings 1'
    // }
  ]

  return (
    <div>
      <SliderGallery
        title="Solid Grey"
        para1="If you’re looking for the ultimate neutral, Solid Grey is your answer. It is a cooler design that complements greys and blues, or can contrast with brick and stucco."
        noteText="We currently do not have any gallery pictures for this membrane. If you have any pictures of this membrane, please send them in to us!"
        galleryImages={galleryImages}
        previouslink="/products/membranes/classic-line"
      />
    </div>
  )
}

export default SolidGreyGallery
